import React, { createContext, useContext } from "react";
import { useMatch } from "react-router-dom";
import { useCasePresence } from "../hooks/useCasePresence";
import { PresenceContextData } from "../types/Presence";

const emptyPresenceContext: PresenceContextData = {
  presenceUsers: [],
  otherPresenceUsers: [],
  isPresenceLoading: false,
  isPresenceLive: false,
  presenceError: null,
};

const PresenceProviderContext = createContext<PresenceContextData>(emptyPresenceContext);

const getProductId = (productId: string | undefined): number | null => {
  if (!productId) {
    return null;
  }

  const parsedProductId = parseInt(productId, 10);

  return parsedProductId > 0 ? parsedProductId : null;
};

export default function PresenceProvider({ children }: { children?: React.ReactNode }) {
  const servicesCaseMatch = useMatch("/services/fall/:productUrlPart/:productId/*");
  const callcenterCaseMatch = useMatch("/services/callcenter/fall/:productUrlPart/:productId/*");
  const externalCaseMatch = useMatch("/services/extern/fall/:productUrlPart/:productId/*");
  const caseMatch = servicesCaseMatch ?? callcenterCaseMatch ?? externalCaseMatch;
  const presenceData = useCasePresence(getProductId(caseMatch?.params.productId));

  return <PresenceProviderContext.Provider value={presenceData}>{children}</PresenceProviderContext.Provider>;
}

export const usePresence = () => {
  return useContext(PresenceProviderContext);
};
